export default class Documento {
    constructor() {
        this.tipo = null;
        this.fecha = null;
        this.numero = null;
    }
}


// WEBPACK FOOTER //
// ./src/model/Documento.js